import {
  NavButton,
  PaginationButtons,
  SvgIcon,
} from 'features/charts-v2/components/chart-legend.styles'

interface LegendPaginationNavProps {
  canPrev: boolean
  canNext: boolean
  onFirst: () => void
  onPrev: () => void
  onNext: () => void
  onLast: () => void
}

/**
 * First/prev/next/last nav buttons for the legend's pagination row. Pure
 * render — page-index math and click gating live in `ChartLegend`.
 */
export function LegendPaginationNav({
  canPrev,
  canNext,
  onFirst,
  onPrev,
  onNext,
  onLast,
}: LegendPaginationNavProps): JSX.Element {
  return (
    <PaginationButtons>
      <NavButton $disabled={!canPrev} onClick={onFirst} aria-label="First page">
        <SvgIcon viewBox="0 0 24 24">
          <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" />
        </SvgIcon>
      </NavButton>
      <NavButton
        $disabled={!canPrev}
        onClick={onPrev}
        aria-label="Previous page"
      >
        <SvgIcon viewBox="0 0 24 24">
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
        </SvgIcon>
      </NavButton>
      <NavButton $disabled={!canNext} onClick={onNext} aria-label="Next page">
        <SvgIcon viewBox="0 0 24 24">
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
        </SvgIcon>
      </NavButton>
      <NavButton $disabled={!canNext} onClick={onLast} aria-label="Last page">
        <SvgIcon viewBox="0 0 24 24">
          <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" />
        </SvgIcon>
      </NavButton>
    </PaginationButtons>
  )
}
